<template>
  <div class="pf-page">

    <!-- Sidebar -->
    <div class="pf-sidebar">
      <div class="pf-avatar-wrap">
        <div class="pf-avatar-ring">
          <img
            v-if="avatarUrl"
            :src="avatarUrl"
            class="pf-avatar-img"
            alt="avatar"
          >
          <div v-else class="pf-avatar-initials">{{ initials }}</div>
        </div>
        <div class="pf-avatar-name">{{ userData.user_name }} {{ userData.user_sobrenome }}</div>
        <div class="pf-avatar-email">{{ userData.user_email }}</div>
      </div>

      <nav class="pf-nav">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          class="pf-nav-item"
          :class="{ 'pf-nav-active': activeTab === tab.id }"
          @click="activeTab = tab.id"
        >
          <span class="pf-nav-icon" v-html="tab.icon"></span>
          {{ tab.label }}
        </button>
      </nav>
    </div>

    <!-- Content -->
    <div class="pf-content">

      <!-- ─── Tab: Geral ─── -->
      <perfil-usuario-geral v-if="activeTab === 'geral'" @avatarUpdated="onAvatarUpdated" />

      <!-- ─── Tab: Alterar Senha ─── -->
      <div v-if="activeTab === 'senha'" class="pf-card">
        <div class="pf-card-header">
          <div class="pf-card-header-icon">
            <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" stroke-width="2"/><path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </div>
          <div>
            <div class="pf-card-title">Alterar Senha</div>
            <div class="pf-card-sub">Recomendamos usar uma senha forte com letras, números e símbolos</div>
          </div>
        </div>
        <alterar-senha />
      </div>

      <!-- ─── Tab: Notificações ─── -->
      <div v-if="activeTab === 'notificacoes'" class="pf-card">
        <div class="pf-card-header">
          <div class="pf-card-header-icon">
            <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M13.73 21a2 2 0 01-3.46 0" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </div>
          <div>
            <div class="pf-card-title">Notificações</div>
            <div class="pf-card-sub">Escolha como e quando deseja ser notificado</div>
          </div>
        </div>
        <div class="pf-notif-list">
          <div v-for="notif in notifPrefs" :key="notif.key" class="pf-notif-row">
            <div class="pf-notif-info">
              <div class="pf-notif-title">{{ notif.title }}</div>
              <div class="pf-notif-desc">{{ notif.desc }}</div>
            </div>
            <button
              class="pf-toggle"
              :class="{ 'pf-toggle-on': notif.enabled }"
              @click="notif.enabled = !notif.enabled"
            >
              <span class="pf-toggle-thumb"></span>
            </button>
          </div>
        </div>
        <div class="pf-footer-row">
          <button class="pf-btn pf-btn-primary" @click="saveNotifications">Salvar preferências</button>
        </div>
      </div>

      <!-- ─── Tab: Endereços ─── -->
      <div v-if="activeTab === 'enderecos'" class="pf-card">
        <div class="pf-card-header">
          <div class="pf-card-header-icon">
            <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="10" r="3" stroke="currentColor" stroke-width="2"/></svg>
          </div>
          <div>
            <div class="pf-card-title">Meus Endereços</div>
            <div class="pf-card-sub">Gerencie seus endereços de entrega e cobrança</div>
          </div>
        </div>
        <account-setting-address @cencelar="reserCuurentAddress()" />
        <div class="pf-address-grid">
          <card-address-item
            v-for="addre in address"
            :key="addre.id"
            :value="addre"
            @deleteAddress="removeAddressUser($event)"
            @editAddress="getAddressById($event)"
            @changePrincipal="updateAddressPrincipal($event)"
          />
        </div>
      </div>

      <!-- ─── Tab: Plano ─── -->
      <div v-if="activeTab === 'plano'" class="pf-card">
        <div class="pf-card-header">
          <div class="pf-card-header-icon">
            <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>
          </div>
          <div>
            <div class="pf-card-title">Seu Plano</div>
            <div class="pf-card-sub">Detalhes do plano atual e opções de upgrade</div>
          </div>
        </div>
        <planos />
      </div>

    </div>
  </div>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PerfilUsuarioGeral from './perfilUsuarioGeral.vue'
import AlterarSenha from './AlterarSenha.vue'
import Planos from './Planos.vue'
import AccountSettingAddress from './AccountSettingAddress.vue'
import CardAddressItem from './components/CardAddressItem.vue'

export default {
  components: {
    CardAddressItem,
    PerfilUsuarioGeral,
    AlterarSenha,
    Planos,
    AccountSettingAddress,
    ToastificationContent,
  },

  data() {
    const ud = JSON.parse(localStorage.getItem('userData')) || {}
    return {
      activeTab: 'geral',
      avatarUrl: ud.user_photo_url || '',
      tabs: [
        {
          id: 'geral',
          label: 'Geral',
          icon: '<svg width="16" height="16" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="2"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
        },
        {
          id: 'senha',
          label: 'Alterar Senha',
          icon: '<svg width="16" height="16" fill="none" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" stroke-width="2"/><path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
        },
        {
          id: 'notificacoes',
          label: 'Notificações',
          icon: '<svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M13.73 21a2 2 0 01-3.46 0" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
        },
        {
          id: 'enderecos',
          label: 'Endereços',
          icon: '<svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="10" r="3" stroke="currentColor" stroke-width="2"/></svg>',
        },
        {
          id: 'plano',
          label: 'Seu Plano',
          icon: '<svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>',
        },
      ],
      notifPrefs: [
        { key: 'email_upload', title: 'Upload concluído', desc: 'Receba um e-mail quando um upload for processado com sucesso', enabled: true },
        { key: 'email_plano', title: 'Vencimento do plano', desc: 'Aviso com antecedência antes do seu plano vencer', enabled: true },
        { key: 'email_novo_play', title: 'Novos plays', desc: 'Resumo diário de plays nos seus vídeos', enabled: false },
        { key: 'email_erro', title: 'Erros e alertas', desc: 'Seja notificado quando ocorrer um erro no processamento', enabled: true },
        { key: 'push_atualizacoes', title: 'Atualizações da plataforma', desc: 'Novidades e melhorias do VSLBooster', enabled: false },
      ],
    }
  },

  computed: {
    userData() {
      return JSON.parse(localStorage.getItem('userData')) || {}
    },
    initials() {
      const u = this.userData
      const n = (u.user_name || '')[0] || ''
      const s = (u.user_sobrenome || '')[0] || ''
      return (n + s).toUpperCase() || '?'
    },
    address() {
      return this.$store.getters['appUserAddress/getAddress']
    },
  },

  mounted() {
    this.findAllUserAddress()
  },

  destroyed() {
    this.reserCuurentAddress()
  },

  methods: {
    onAvatarUpdated(url) {
      this.avatarUrl = url
    },
    saveNotifications() {
      this.$notify({ title: 'Preferências salvas', message: 'Suas configurações de notificação foram atualizadas.', type: 'success' })
    },
    async getAddressById(id) {
      await this.$store.dispatch('appUserAddress/findAddressById', { id_user: this.userData.id, id_address: id })
        .then(resp => { this.$store.commit('appUserAddress/SET_CURRENT_ADDRESS', resp.data) })
    },
    async findAllUserAddress() {
      await this.$store.dispatch('appUserAddress/findAllUser', { id_user: this.userData.id })
    },
    async reserCuurentAddress() {
      await this.$store.dispatch('appUserAddress/reserCuurentAddress')
      await this.$store.dispatch('appUserAddress/findAllUser', { id_user: this.userData.id })
    },
    async updateAddressPrincipal(address) {
      await this.$store.dispatch('appUserAddress/updateAddressPrincipal', { id_user: this.userData.id, id_address: address.id })
        .then(resp => {
          this.$toast({ component: ToastificationContent, props: { title: 'Atualizado', text: resp.data.message, icon: 'CheckIcon', variant: 'success' } })
          this.findAllUserAddress()
        })
        .catch(error => {
          this.$toast({ component: ToastificationContent, props: { title: 'Erro', text: error.response.data.message, icon: 'XIcon', variant: 'danger' } })
        })
    },
    async removeAddressUser(address) {
      await this.$store.dispatch('appUserAddress/deleteAddress', { id_user: this.userData.id, id_address: address.id })
        .then(resp => {
          this.$toast({ component: ToastificationContent, props: { title: 'Removido', text: resp.data.message, icon: 'CheckIcon', variant: 'success' } })
          this.findAllUserAddress()
        })
        .catch(error => {
          this.$toast({ component: ToastificationContent, props: { title: 'Erro', text: error.response.data.message, icon: 'XIcon', variant: 'danger' } })
        })
    },
  },
}
</script>

<style scoped>
.pf-page {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  padding: 8px 0;
}

/* ─── Sidebar ─── */
.pf-sidebar {
  width: 240px;
  flex-shrink: 0;
  background: var(--dk-bg-card, #fff);
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(13,51,73,0.08);
  overflow: hidden;
  position: sticky;
  top: 80px;
}

.pf-avatar-wrap {
  background: linear-gradient(135deg, #0D3349 0%, #1a4d6b 100%);
  padding: 28px 20px 22px;
  text-align: center;
}
.pf-avatar-ring {
  width: 80px; height: 80px; border-radius: 50%;
  margin: 0 auto 12px;
  border: 3px solid rgba(232,106,16,0.8);
  overflow: hidden;
  display: flex; align-items: center; justify-content: center;
  background: rgba(255,255,255,0.1);
}
.pf-avatar-img { width: 100%; height: 100%; object-fit: cover; }
.pf-avatar-initials { font-size: 26px; font-weight: 700; color: #E86A10; }
.pf-avatar-name { font-size: 14px; font-weight: 700; color: #fff; margin-bottom: 4px; }
.pf-avatar-email { font-size: 11.5px; color: rgba(255,255,255,0.55); word-break: break-all; }

.pf-nav { padding: 10px 0; }
.pf-nav-item {
  display: flex; align-items: center; gap: 10px;
  width: 100%; padding: 11px 18px;
  background: none; border: none; cursor: pointer;
  font-size: 13.5px; font-weight: 500; color: var(--dk-text-secondary, #6b7280);
  text-align: left; transition: all 0.15s;
}
.pf-nav-item:hover { background: var(--dk-bg-input, #f9fafb); color: var(--dk-text-primary, #0D3349); }
.pf-nav-active {
  background: rgba(232,106,16,0.08) !important;
  color: #E86A10 !important;
  font-weight: 700;
  border-right: 3px solid #E86A10;
}
.pf-nav-icon { display: flex; color: currentColor; opacity: 0.8; }

/* ─── Content ─── */
.pf-content { flex: 1; min-width: 0; }

.pf-card {
  background: var(--dk-bg-card, #fff);
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(13,51,73,0.08);
  overflow: hidden;
}

.pf-card-header {
  display: flex; align-items: flex-start; gap: 14px;
  padding: 20px 24px;
  background: linear-gradient(135deg, #0D3349, #1a4d6b);
  color: #fff;
  margin-bottom: 0;
}
.pf-card-header-icon {
  width: 40px; height: 40px; border-radius: 10px; flex-shrink: 0;
  background: rgba(232,106,16,0.85);
  display: flex; align-items: center; justify-content: center;
}
.pf-card-title { font-size: 15px; font-weight: 700; }
.pf-card-sub { font-size: 12px; opacity: 0.6; margin-top: 3px; }

/* ─── Notifications ─── */
.pf-notif-list { padding: 8px 0; }
.pf-notif-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid var(--dk-border-light, #f5f6fa);
}
.pf-notif-row:last-child { border-bottom: none; }
.pf-notif-title { font-size: 14px; font-weight: 600; color: var(--dk-text-primary, #0D3349); }
.pf-notif-desc { font-size: 12.5px; color: var(--dk-text-muted, #8a94a6); margin-top: 3px; }

.pf-toggle {
  width: 44px; height: 24px; border-radius: 12px; flex-shrink: 0;
  background: var(--dk-border, #dde1e8); border: none; cursor: pointer; position: relative;
  transition: background 0.2s;
}
.pf-toggle-on { background: #E86A10; }
.pf-toggle-thumb {
  position: absolute; top: 3px; left: 3px;
  width: 18px; height: 18px; border-radius: 50%; background: var(--dk-bg-card, #fff);
  transition: transform 0.2s; display: block;
  box-shadow: 0 1px 4px rgba(0,0,0,0.15);
}
.pf-toggle-on .pf-toggle-thumb { transform: translateX(20px); }

.pf-footer-row {
  padding: 16px 24px;
  border-top: 1px solid var(--dk-border-light, #f5f6fa);
  display: flex; justify-content: flex-end;
}
.pf-btn { padding: 10px 22px; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; border: none; }
.pf-btn-primary { background: linear-gradient(135deg, #E86A10, #f08535); color: #fff; box-shadow: 0 4px 12px rgba(232,106,16,0.3); }
.pf-btn-primary:hover { background: linear-gradient(135deg, #cf5e0d, #E86A10); }

/* ─── Address grid ─── */
.pf-address-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; padding: 16px 24px; }

@media (max-width: 768px) {
  .pf-page { flex-direction: column; }
  .pf-sidebar { width: 100%; position: static; }
  .pf-address-grid { grid-template-columns: 1fr; }
}
</style>
